import React from 'react';

const VgImage = () => {
  return (
    <div className="py-20 bg-white flex justify-center items-center">
      <img
        className="object-cover object-center max-w-full max-h-full"
        src="https://onedrive.live.com/embed?resid=38E489A2E9BE257B%2157262&authkey=%21AA1v6mpkNVyr2gM&width=6608&height=1452"
        alt="Vg image"
      />
    </div>
  );
};

export default VgImage;
